import React from "react";

interface imagePreviewProps {
  imageSrc: string;
}

const ImagePreview: React.FC<imagePreviewProps> = ({ imageSrc }) => {
  return (
    <React.Fragment>
      <img
        src={imageSrc}
        alt=""
        width="100%"
        height="100%"
        style={{
          borderRadius: "4px",
          opacity: 1,
          objectFit: "contain",
          maxWidth: "100%",
          maxHeight: "100%",
          display: "block",
        }}
      />
    </React.Fragment>
  );
};

export default ImagePreview;
